
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5571_28584)"}},[_c('path',{attrs:{"d":"M10.08 9.62c.61.25 1.26.38 1.92.38.33 0 .65-.03.98-.1.97-.19 1.85-.67 2.56-1.37.7-.7 1.18-1.58 1.37-2.56.19-.96.1-1.96-.28-2.89A4.938 4.938 0 0014.78.84c-1.93-1.29-4.69-1.01-6.32.62C7.52 2.4 7 3.66 7 5c0 .99.29 1.95.84 2.78.55.82 1.33 1.46 2.24 1.84zM12 12C5.38 12 0 16.93 0 23c0 .55.45 1 1 1h22c.55 0 1-.45 1-1 0-6.07-5.38-11-12-11z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5571_28584"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    